import { AppRoutes } from "config/router";
import { useContext } from "react";
import { getAppContext } from 'config/AppContext';
import { gql } from "@apollo/client";
import WorkView from "./WorkView";
import { Roles } from "utilities/app-utilities";
import PageView from "components/common/page/PageView";

const harvestViewPageQuery = gql`
query workViewPage($id: Int) {
  harvestAgricultureWork(id: $id) {
      id
      startDate
      name
      note
      harvests {
        items {
          id
          kg
          fruit {
            name
            id
          }
          cartQuantity
          hideFromMultiUpdate
          harvestFruitGroups {
            items {
              id
              fruitGroup {
                name
                id
              }
            }
          }
          harvestFruitCategories {
            items {
              id
              fruitCategory {
                id
                name
              }
            }
          }
        }
      }
      season {
        name
        id
      }
      workers {
        count
        priceSum
        items {
          person {
            id
            name
          }
          price
          id
        }
      }
    }
  }  
`;

const WorkViewPage = () => {
  const context = getAppContext(useContext);
  return (
    <PageView
      title="pages.agriculture.work.harvest.view"
      onDelete={context.userHasRole(Roles.AGRICULTURE_WORK_WRITE) ? "harvestAgricultureWorkDelete" : undefined}
      editUrl={context.userHasRole(Roles.AGRICULTURE_WORK_WRITE) ? AppRoutes.AGRICULTURE_WORK_HARVEST_EDIT : undefined}
      query={harvestViewPageQuery}
      queryDataPropertyName="harvestAgricultureWork"
      name="harvest-view-page"
      view={i => <WorkView model={i.harvestAgricultureWork!} view="default" name="work-view-page" />}
    />
  );
};

export default WorkViewPage;
